import { Injectable } from "@angular/core";
import { BaseLoopBackApi } from "../sdk";
import { MyApp } from "../app/app.component";
import { Observable } from "rxjs";
import {HttpHeaders} from "@angular/common/http";

/**
 * Llama alas funciones del server
 */
@Injectable()
export class ServerProvider {

    public static myApp:MyApp;

    constructor(){
    }

    public static init(app:MyApp){
        this.myApp = app;
        
    }

    public static getCustomHeaders(headers: HttpHeaders) {
        if (headers == null) {
            headers = new HttpHeaders();
        }
        headers = headers.append("odoo-hostid", ServerProvider.myApp.getHostId()); // Id host al que se realiza la petición
        return headers;
    }

    /**
     * Realiza contra el servidor una busqueda
     * @param service servicio en donde buscar
     * @param query json con los datos a buscar
     */
    public static find(service:BaseLoopBackApi, query:any, isOpenErpApp:boolean=false ):Observable<any>{

        let queryApp:any = query;
        queryApp.openerp = {
            app: isOpenErpApp // indicador de que es de tipo app
        };
        
        return service.find(queryApp, this.getCustomHeaders);
        
    }

    /**
     * Busca por un id
     * @param service servicio en donde buscar
     * @param id id a buscar
     * @param query json con los datos a buscar
     */
    public static findById(service:BaseLoopBackApi, id, query:any,  isOpenErpApp:boolean=false):Observable<any>{
        let queryApp:any = query;
        queryApp.openerp = {
            app: isOpenErpApp // indicador de que es de tipo app
        };
        
        return service.findById(id, queryApp, this.getCustomHeaders);
    }

    /**
     * Si no se le envia ID, haremos una create
     * Si se le envia el id, se hará una update
     * @param service 
     * @param query 
     * @param isOpenErpApp 
     */
    public static createOrUpdate(service:BaseLoopBackApi, query:any, isOpenErpApp:boolean=false):Observable<any>{
        if(query.id==null || query.id <=0){
            return this.create(service, query, isOpenErpApp);
        }else{
            return this.update(service, query, isOpenErpApp);
        }
    }

    /**
     * Inserta un dato en el servidor
     * @param service servicio en donde insertar
     * @param query json con los datos a insertar
     */
    public static create(service:BaseLoopBackApi, query:any, isOpenErpApp:boolean=false):Observable<any>{

        let queryApp:any = query;
        queryApp.openerp = {
            app: isOpenErpApp // indicador de que es de tipo app
        };

        return service.create(queryApp, this.getCustomHeaders);
    }


    /**
     * Actualiza un dato en el servidor
     * @param service servicio a actualizar
     * @param id id del dato a actualizar
     * @param query datos a actualizar
     */
    public static update(service:BaseLoopBackApi, query:any, isOpenErpApp:boolean=false):Observable<any>{
        
        //obtenemos el id de la query
        let idQuery;

        if(query.id){
            idQuery = query.id;
        }else{
            //id necesario, error
            throw new Error('error-update-not-id');
        }

        //realizamos copia de la query
        var data = JSON.parse(JSON.stringify(query));
        data.openerp = {
            app: isOpenErpApp // indicador de que es de tipo app
        };

        //eliminamos id
        delete data.id;

        return service.updateAttributes(idQuery, data, this.getCustomHeaders );
    }

    /**
     * Borra un item del servidor
     * @param service 
     * @param id 
     */
    public static deleteById(service:BaseLoopBackApi, id:number):Observable<any>{
        return service.deleteById(id, this.getCustomHeaders);
    }

}


// WEBPACK FOOTER //
// ./src/providers/server-provider.ts